import LandingPageFeature from 'features/LandingPage';
import { Route, Routes } from 'react-router-dom';
import './App.css';

function App() {
  return (
    <div className="App">
      {/* <Header /> */}

      <Routes>
        <Route path="/" element={<LandingPageFeature />}></Route>
      </Routes>
      {/* ✅ Pagination */}

      {/* <Footer /> */}
    </div>
  );
}

export default App;
